export function getdata() {
	var obj = {
			list: {
				nsrlx: [{
					title: '土地使用权人',
					label: 1,
				}, {
					title: '集体土地使用人',
					label: 2,
				}, {
					title: '无偿使用人',
					label: 3,
				}, {
					title: '代管人',
					label: 4,
				}, {
					title: '实际使用人',
					label: 5,
				}],
				tdxz: [{
					title: '私有',
					label: 1,
				}, {
					title: '国有',
					label: 2,
				}],
				tdqdfs: [{
					title: '划拨',
					label: 1,
				}, {
					title: '出让',
					label: 2,
				}, {
					title: '转让',
					label: 3,
				}, {
					title: '租赁',
					label: 4,
				}, {
					title: '其他',
					label: 5,
				}],
				tdyt: [{
					title: '工业',
					label: 1,
				}, {
					title: '商业',
					label: 2,
				}, {
					title: '居住',
					label: 3,
				}, {
					title: '综合',
					label: 4,
				}, {
					title: '房地产开发企业的开发用地',
					label: 5,
				}, {
					title: '其他',
					label: 5,
				}]
			},
			dataList: {
				ccxwtd_sh: {
					disabledccxwtd_sh: false,
					ccxwtd_sh: {
						cellCode: "ccxwtd_sh",
						cellType: "1",
						cellVal: "240040043.08"
					},
				},
				ccxwtd_syqrmc: {
					disabledccxwtd_syqrmc: false,
					ccxwtd_syqrmc: {
						cellCode: "ccxwtd_syqrmc",
						cellType: "1",
						cellVal: "240040043.08"
					},
				},
				ccxwtd_bh: {
					disabledccxwtd_bh: true,
					ccxwtd_bh: {
						cellCode: "ccxwtd_bh",
						cellType: "1",
						cellVal: "240040043.08"
					},
				},
				ccxwtd_mc: {
					disabledccxwtd_mc: false,
					ccxwtd_mc: {
						cellCode: "ccxwtd_mc",
						cellType: "1",
						cellVal: "240040043.08"
					},
				},
				ccxwtd_cqzh: {
					disabledccxwtd_cqzh: false,
					ccxwtd_cqzh: {
						cellCode: "ccxwtd_cqzh",
						cellType: "1",
						cellVal: "240040043.08"
					},
				},
				ccxwtd_dydm: {
					disabledccxwtd_dydm: false,
					ccxwtd_dydm: {
						cellCode: "ccxwtd_dydm",
						cellType: "1",
						cellVal: "240040043.08"
					},
				},
				ccxwtd_zdh: {
					disabledccxwtd_zdh: false,
					ccxwtd_zdh: {
						cellCode: "ccxwtd_zdh",
						cellType: "1",
						cellVal: "240040043.08"
					},
				},
				ccxwtd_ssswj: {
					disabledccxwtd_ssswj: true,
					ccxwtd_ssswj: {
						cellCode: "ccxwtd_ssswj",
						cellType: "1",
						cellVal: "240040043.08"
					},
				},
				ccxwtd_dz: {
					sheng: '',
					shi: '',
					qu: '',
					xian: '',
					xz: '',
				},
				ccxwtd_qdsj: '',
				ccxwtd_bglx: {
					disabledccxwtd_bglx: false,
					ccxwtd_bglx: {
						cellCode: "ccxwtd_bglx",
						cellType: "1",
						cellVal: "240040043.08"
					},
				},
				ccxwtd_mj: {
					disabledccxwtd_mj: false,
					ccxwtd_mj: {
						cellCode: "ccxwtd_mj",
						cellType: "1",
						cellVal: "240040043.08"
					},
				},
				ccxwtd_dj: {
					disabledccxwtd_dj: false,
					ccxwtd_dj: {
						cellCode: "ccxwtd_dj",
						cellType: "1",
						cellVal: "240040043.08"
					},
				},
				ccxwtd_tddj: {
					disabledccxwtd_tddj: false,
					ccxwtd_tddj: {
						cellCode: "ccxwtd_tddj",
						cellType: "1",
						cellVal: "240040043.08"
					},
				},
				ccxwtd_sebz: {
					disabledccxwtd_sebz: true,
					ccxwtd_sebz: {
						cellCode: "ccxwtd_sebz",
						cellType: "1",
						cellVal: "240040043.08"
					},
				},
				ccxwtd_bgsj: '',
				ccxwtd_xz: '',
				ccxwtd_qdfs: '',
				ccxwtd_nsrlx: '',
				ccxwtd_yt: '',
				ccxwtd_2_1_1: {
					disabledccxwtd_2_1_1: false,
					ccxwtd_2_1_1: {
						cellCode: "ccxwtd_2_1_1",
						cellType: "1",
						cellVal: "240040043.08"
					},
				},
				ccxwtd_2_1_2: '',
				ccxwtd_2_1_3: '',
				ccxwtd_2_1_4: {
					disabledccxwtd_2_1_4: false,
					ccxwtd_2_1_4: {
						cellCode: "ccxwtd_2_1_4",
						cellType: "1",
						cellVal: "240040043.08"
					},
				},
				ccxwtd_2_1_5: {
					disabledccxwtd_2_1_5: false,
					ccxwtd_2_1_5: {
						cellCode: "ccxwtd_2_1_5",
						cellType: "1",
						cellVal: "240040043.08"
					},
				},
				ccxwtd_2_2_1: {
					disabledccxwtd_2_2_1: false,
					ccxwtd_2_2_1: {
						cellCode: "ccxwtd_2_2_1",
						cellType: "1",
						cellVal: "240040043.08"
					},
				},
				ccxwtd_2_2_2: '',
				ccxwtd_2_2_3: '',
				ccxwtd_2_2_4: {
					disabledccxwtd_2_2_4: false,
					ccxwtd_2_2_4: {
						cellCode: "ccxwtd_2_2_4",
						cellType: "1",
						cellVal: "240040043.08"
					},
				},
				ccxwtd_2_2_5: {
					disabledccxwtd_2_2_5: false,
					ccxwtd_2_2_5: {
						cellCode: "ccxwtd_2_2_5",
						cellType: "1",
						cellVal: "240040043.08"
					},
				},
				ccxwtd_2_3_1: {
					disabledccxwtd_2_3_1: false,
					ccxwtd_2_3_1: {
						cellCode: "ccxwtd_2_3_1",
						cellType: "1",
						cellVal: "240040043.08"
					},
				},
				ccxwtd_2_3_2: '',
				ccxwtd_2_3_3: '',
				ccxwtd_2_3_4: {
					disabledccxwtd_2_3_4: false,
					ccxwtd_2_3_4: {
						cellCode: "ccxwtd_2_3_4",
						cellType: "1",
						cellVal: "240040043.08"
					},
				},
				ccxwtd_2_3_5: {
					disabledccxwtd_2_3_5: false,
					ccxwtd_2_3_5: {
						cellCode: "ccxwtd_2_3_5",
						cellType: "1",
						cellVal: "240040043.08"
					},
				},
			},
			new:{}
	}
	return obj
}
